<template>
  <div class="app-container vote-list">
    <div class="vote-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="vote-list-filter-value" v-model.trim="listQuery.subject" @keyup.enter.native="searchChange" clearable size="small" placeholder="主题"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="vote-list-filter-value" v-model="listQuery.type" clearable size="small" placeholder="类型">
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="vote-list-filter-value" v-model="listQuery.collectType" clearable size="small" placeholder="收集方式">
              <el-option
                v-for="item in collectTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="vote-list-filter-value" v-model="listQuery.statusEnum" clearable size="small" placeholder="状态">
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
        </el-col>
        <el-col :span="6">
        </el-col>
        <el-col :span="6">
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-button class="vote-list-filter-search" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="vote-list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <avue-crud ref="crud"
                 :page.sync="page"
                 :data="tableData"
                 :table-loading="tableLoading"
                 :option="tableOption"
                 @current-change="currentChange"
                 @size-change="sizeChange">

        <template slot="subject" slot-scope="scope">
          <el-tooltip :content="scope.row.subject" placement="top">
            <div class="clamp-text">{{scope.row.subject}}</div>
          </el-tooltip>
        </template>

        <template slot="description" slot-scope="scope">
          <el-tooltip :content="scope.row.description" placement="top">
            <div class="clamp-text">{{scope.row.description}}</div>
          </el-tooltip>
        </template>

        <template slot="qrUrl" slot-scope="scope">
          <el-button type="text" @click="previewImg(scope.row.qrUrl)">
            <div>modules/vote/{{scope.row.id}}</div>
          </el-button>
        </template>

        <template slot="menuLeft">
          <el-button type="primary"
            @click="handleAdd"
            icon="el-icon-add"
            size="small">创建投票</el-button>
          <br /><br />
        </template>
        <template slot-scope="scope"
          slot="menu">
          <el-button type="text"
            v-if="permissions.vote_publish && !scope.row.isPublish"
            size="mini"
            @click="handlePublish(scope.row,scope.index)">发布</el-button>
          <el-button type="text"
            v-if="permissions.vote_pause && scope.row.isPublish"
x            size="mini"
            @click="handlePause(scope.row,scope.index)">暂停</el-button>
          <el-button type="text"
            icon="el-icon-view"
            size="mini"
            @click="handleView(scope.row,scope.index)">查看</el-button>
          <el-button type="text"
            icon="el-icon-edit"
            size="mini"
            :disabled="scope.row.statusEnum === statusOptions[2].label
            || scope.row.isPublish"
            title="投票结束后不可编辑"
            @click="handleEdit(scope.row,scope.index)">编辑</el-button>
          <el-button type="text"
            icon="el-icon-delete"
            size="mini"
            @click="handleDelete(scope.row,scope.index)">删除</el-button>
          <el-button type="text"
            icon="el-icon-view"
            size="mini"
            @click="handlePreview(scope.row,scope.index)">预览</el-button>
          <el-button
            title="复制链接"
            size="mini"
            type="text"
            icon="el-icon-share"
            @click="copyLink(scope.row)">复制链接</el-button>
        </template>
      </avue-crud>
    </basic-container>
    <el-dialog
      title="投票详情"
      :visible.sync="imgDialogVisible"
      fullscreen
      custom-class="preview-img-dialog">
      <div @click="imgDialogVisible = false">
        <vue-qr :text="previewImgUrl" :size="qrCodeSize"></vue-qr>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="userPreviewQrcodeDialogVisible"
      fullscreen
      custom-class="preview-img-dialog">
      <div @click="userPreviewQrcodeDialogVisible = false">
        <vue-qr :text="userPreviewQrcodeUrl" :size="qrCodeSize"></vue-qr>
      </div>
    </el-dialog>
    <el-dialog
      :title="(isPublish ? '发布' : '暂停') + '确认'"
      :visible.sync="publishOrPauseVoteDialogVisible"
      width="35%">
       <template>
        <el-row class="dialog-body-row">
          <el-input type="textarea" :rows="3" v-if="isSendMessage" v-model="message" :maxlength="512"></el-input>
        </el-row>
        <el-row class="dialog-body-row">
          <el-checkbox label="是否给用户发送消息通知" v-model="isSendMessage"></el-checkbox>  
        </el-row>
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="publishOrPauseVoteDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handlePauseOrPublish">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import vueQr from 'vue-qr'
import { getVoteList, voteDel, votePublish, votePause } from '@/api/app/vote'
import { tableOption, statusOptions, typeOptions, collectTypeOptions } from '@/const/crud/app/vote'
import { mapGetters } from "vuex"
export default {
  name: 'vote',
  computed: {
    ...mapGetters(['permissions']),
  },
  data() {
    return {
      tableOption,
      statusOptions,
      typeOptions,
      collectTypeOptions,
      tableLoading: false,
      imgDialogVisible: false,
      previewImgUrl: '',
      userPreviewQrcodeDialogVisible: false,
      userPreviewQrcodeUrl: '',
      qrCodeSize: 300,
      tableData: [],
      time: [],
      listQuery: {
        current: 1,
        size: 10,
        subject: '',
        type: '',
        collectType: '',
        statusEnum: '',
        startTime: '',
        endTime: '',
      },
      page: {
        total: 0, // 总记录数
        currentPage: 1, // 当前页数
        pageSize: 10 // 每页显示多少条
      },
      publishOrPauseVoteDialogVisible: false,
      publishOrPauseVoteId: undefined,
      isPublish: true,
      message: '',
      isSendMessage: false,
    }
  },
  created() {
    this.getList();
  },
  activated() {
    this.getList();
  },
  methods: {
    queryTimeChange(value) {
      this.listQuery.startTime = value[0];
      this.listQuery.endTime = value[1];
    },
    formatData(records) {
      if (Array.isArray(records)) {
        records.forEach(record => {
          record.isMultiple = record.isMultiple ? '是' : '否';
          record.statusEnum = statusOptions.find((v) => (v.value == record.statusEnum)).label;
          record.type = typeOptions.find((v) => (v.value == record.type)).label;
          record.collectType = collectTypeOptions.find((v) => (v.value == record.collectType)).label;
          if(this.validatenull(record.participantCount)) record.participantCount = 0;
        })
      }
      return records
    },
    searchReset() {
      this.time = []
      this.listQuery = {}
      this.searchChange()
    },
    searchChange() {
      this.page.currentPage = 1
      this.listQuery.current = 1
      this.getList()
    },
    currentChange(val) {
      this.page.currentPage = val
      this.listQuery.current = val
      this.getList()
    },
    sizeChange(val) {
      this.page.currentPage = 1
      this.listQuery.current = 1
      this.page.pageSize = val
      this.listQuery.size = val
      this.getList()
    },
    handleAdd: function() {
      this.$router.push({
        path: '/app/vote/add'
      })
    },
    handlePublish(row, index) {
      this.publishOrPauseVoteDialogVisible =  true;
      this.isPublish = true;
      this.publishOrPauseVoteId = row.id;
    },
    handlePause(row, index) {
      this.publishOrPauseVoteDialogVisible =  true;
      this.isPublish = false;
      this.publishOrPauseVoteId = row.id;
    },
    handlePauseOrPublish() {
      if (this.isSendMessage && (this.message === '' || this.message.trim() === '')) {
        return this.$message.error('请填写消息内容');
      }
      if (this.isPublish) {
        votePublish(this.publishOrPauseVoteId, this.isSendMessage, this.message).then(response => {
          this.$message.success('发布成功');
          this.getList();
          this.publishOrPauseVoteDialogVisible =  false;
        });
      } else {
        votePause(this.publishOrPauseVoteId, this.isSendMessage, this.message).then(response => {
          this.$message.success('暂停成功');
          this.getList();
          this.publishOrPauseVoteDialogVisible =  false;
        });
      }
    },
    handleEdit(row, index) {
      this.$router.push({
        path: `/app/vote/edit/${row.id}`,
      })
    },
    handleView(row, index) {
      this.$router.push({
        path: `/app/vote/detail/${row.id}`,
      })
    },
    handlePreview(row, index) {
      this.userPreviewQrcodeUrl = `${row.qrUrl}?isPreview=true`;
      this.userPreviewQrcodeDialogVisible = true;
    },
    handleDelete(row, index) {
      let _this = this, tips = ''
      if(row.statusEnum === statusOptions[1].label){
        tips = '当前状态为' + row.statusEnum + '，';
      }
      this.$confirm(tips + '是否确认删除：' + row.subject + ' ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        voteDel(row.id).then(response => {
          if (response.data.data) {
            _this.getList();
            _this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success'
            })
          }
        }).catch(function(err) {
          console.error(err)
          _this.$message({
            showClose: true,
            message: '操作失败',
            type: 'error'
          })
        })
      })
    },
    copyLink(row) {
      const url = process.env.VUE_APP_BASIC_PAGE_PATH + `/modules/vote/${row.id}`
      this.$copyText(url).then(
        res => {
          this.$message({
            showClose: true,
            type: 'success',
            message: '已成功复制'
          })
        },
        err => {
          this.$message({
            showClose: true,
            type: 'error',
            message: '失败'
          })
        }
		  )
    },
    getList() {
      this.tableLoading = true
      getVoteList(this.listQuery).then(response => {
        this.tableData = this.formatData(response.data.data.records);
        this.page.total = response.data.data.total;
        this.tableLoading = false;
      }).catch(error => {
        console.error(error)
        this.$message({
          message: '获取投票列表失败',
          type: 'error'
        })
        this.tableLoading = false;
      })
    },
    previewImg(url) {
      this.previewImgUrl = url;
      this.imgDialogVisible = true;
    },
  }
}
</script>

<style lang="scss" scoped>
.vote-list {
  &-filter {
    margin: 0px 10px;
    background-color: #fff;
    padding-top: 20px;
    padding-left: 22px;

    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }

    &-value {
      width: 96%!important;
    }

    &-date {
      width: 96%!important;
    }

    &-reset {
      float: right;
      margin-right: 8px;
    }

    &-search {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
  .clamp-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}
/deep/ .el-dialog.preview-img-dialog{
  background: rgba(0, 0, 0, 0.5);
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 40px;
      right: 40px;
      .el-dialog__close {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        border: 2px solid #fff;
        border-radius: 50%;
        padding: 5px;
      }
    }
  }
  .el-dialog__body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0;
    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}
.dialog-body-row {
  margin-top: 8px;
}
</style>

